<template>
  <!-- TODO: 此頁面仍然沒有進入點 -->
  <div
    id="postalPatchList"
    class="pageRoot"
  >
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            批次包裹登記
          </div>
          <div class="tip">
            提供一次性匯入同類型包裹
          </div>
        </div>
        <div class="right">
          <el-button
            round
            @click="$toPage('postalDespatcher_v2')"
          >
            返回一般登記
          </el-button>
        </div>
      </div>
      <div class="title_bar center">
        <div class="left">
          <span class="questionnaire"><span @click="openPage()">如何批次登記同類型包裹</span></span>
        </div>
        <div class="right">
          <el-button
            round
            @click="rigister()"
          >
            登記
          </el-button>
        </div>
      </div>
      <el-table
        class="newslist"
        :data="listData"
        empty-text="目前無任何包裹"
      >
        <el-table-column
          type="index"
          width="50"
        />
        <el-table-column
          prop="FileName"
          label="匯入檔案名稱"
        >
          <template
            slot-scope="scope"
            class="file-name"
          >
            <a
              style="cursor:pointer;"
              @click="goDetail(scope.row)"
            >{{ scope.row.FileName }}</a>
          </template>
        </el-table-column>
        <el-table-column
          prop="CreateAt"
          label="匯入時間"
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.UpdateAt? scope.row.UpdateAt.substr(0,16).replace(/-/g,"/") : scope.row.CreateAt.substr(0,16).replace(/-/g,"/") }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="Status"
          label="類型"
          width="110"
        >
          <template slot-scope="scope">
            {{ scope.row.TypeName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="SuccessCount"
          label="登記成功筆數"
          width="110"
        >
          <template slot-scope="scope">
            {{ scope.row.SuccessCount }}/{{ scope.row.Total }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" v-if="scope.row.Status == 3" @click="rigister(true,scope.row.Id)" plain>重傳</el-button>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="Status"
          label="狀態"
          width="80"
        >
          <template slot-scope="scope">
            <span :class="scope.row.statusObj.class"> {{ scope.row.statusObj.text }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="Status"
          label="上傳結果說明"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.statusObj.desc }}</span>
          </template>
        </el-table-column>
      </el-table>
      <TableLoading :is-loading="loading" />
    </div>
    <el-dialog
      id="setting"
      ref="upload"
      title="新增批次包裹登記Excel檔案"
      :visible.sync="openUpload"
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
      :lock-scroll="true"
      center
    >
      <el-form
        ref="fileUpload"
        :model="editData"
        status-icon
        @submit.native.prevent
      >
        <el-form-item
          label="選擇包裹登記類型"
          class="payMethods"
        >
          <div class="remind">
            批次上傳僅限登記同一個類型的包裹
          </div>
          <p>
            <template v-for="(type,type_ind) in typeList">
              <el-tag
                :key="type_ind"
                :class="nowType == type['Value'] ? 'active': ''"
                @click="nowType = type.Value"
              >
                {{ type.Name }}
              </el-tag>
            </template>
          </p>
        </el-form-item>
        <el-form-item label="匯入Excel檔案">
          <el-upload
            class="uploadFileWrap"
            accept="xlsx/*"
            :on-change="handleUploadFile"
            :auto-upload="false"
            :show-file-list="false"
            action=""
          >
            <div
              slot="tip"
              class="uploadedFile"
              :class="{'active':editData.UploadFile}"
            >
              <div
                v-show="editData.UploadFile"
                class="fileName"
              >
                <span>{{ editData.UploadFile?editData.UploadFile.name:'' }}</span>
                <i
                  class="el-icon-close"
                  aria-hidden="true"
                  @click="clearFile"
                />
              </div>
            </div>
            <el-button
              size="small"
              :disabled="editData.UploadFile?true:false"
              icon="icon-upload2"
              round
            >
              選擇檔案
            </el-button>
          </el-upload>
          <p class="emptyFile">
            請點此<span @click="getExampleExcel()">下載空白範本</span>開始登記，儲存檔案儲存檔案後請點擊【選擇檔案】按鈕匯入
          </p>
        </el-form-item>
      </el-form>
      <div class="remind">
        <div class="container">
          <div class="title">
            登記注意事項 <span
              class="tutorial"
              @click="openPage()"
            >(查看教學)</span>
          </div>
          <ul class="desc">
            <li>1.請將收件人依照戶別順序對照輸入，勿任意增減及調整欄位，否則會造成登記錯誤。</li>
            <li>2.填寫完確認該戶資料無誤後請在【是否上傳(E欄)】打勾，未勾選的戶別不會上傳。</li>
            <li>3.核對勾選之戶別名單後，儲存檔案並上傳戶別名單。</li>
            <li>4.包裹登記時請避免其他裝置登入社區同時操作郵務【登記】，以避免流水號重複。</li>
            <li>5.批次登記包裹不提供批次條碼登記、隱私、位置、廠商及物流等資訊上傳</li>
          </ul>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="cancelUpload"
        >取消</el-button>
        <el-button
          :type="canUpload?'primary':'info'"
          round
          :disabled="canUpload?false:true"
          @click="upLoad()"
        >上傳</el-button>
      </span>
    </el-dialog>
    <el-dialog
      id="setting"
      ref="uploadAgain"
      title="重新上傳批次郵務登記Excel檔案"
      :visible.sync="openUploadAgain"
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
      :lock-scroll="true"
      center
    >
      <div class="comment">
        <p>Step1. 請打開原始匯入檔案，核對失敗明細中錯誤原因已經修正</p>
        <p>Step2. 請將修正檔案儲存後，請點擊【選擇檔案】按鈕匯入</p>
      </div>
      <el-form
        ref="fileUpload"
        :model="editData"
        status-icon
        @submit.native.prevent
      >
        <el-form-item>
          <el-upload
            class="uploadFileWrap"
            accept="xlsx/*"
            :on-change="handleUploadFile"
            :auto-upload="false"
            :show-file-list="false"
            action=""
          >
            <div
              slot="tip"
              class="uploadedFile"
              :class="{'active':editData.UploadFile}"
            >
              <div
                v-show="editData.UploadFile"
                class="fileName"
              >
                <span>{{ editData.UploadFile?editData.UploadFile.name:'' }}</span>
                <i
                  class="el-icon-close"
                  aria-hidden="true"
                  @click="clearFile"
                />
              </div>
            </div>
            <el-button
              size="small"
              :disabled="editData.UploadFile?true:false"
              icon="icon-upload2"
              round
            >
              選擇檔案
            </el-button>
          </el-upload>
          <!-- <p class="emptyFile">第一次產單請點此<span @click="getExampleExcel()">下載空白範本</span></p> -->
        </el-form-item>
      </el-form>
      <div class="remind">
        <div class="container">
          <div class="title">
            更正錯誤戶別登記資料須注意以下事項：
          </div>
          <ul class="desc">
            <li>1. 重新上傳的郵務資料僅會針對失敗狀態的戶別資料更新，原先成功登記資料，重新上傳時將不會再重複登記或更新登記內容。</li>
            <li>2. 重新上傳檔案，無法變更郵務類型，如欲變更請使用[新增登記]。</li>
            <li>3. 上傳完畢後請至原上傳列表明細中查看上傳狀態。</li>
          </ul>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="cancelUpload()"
        >取消</el-button>
        <el-button
          type="primary"
          round
          @click="upLoad(true)"
        >上傳</el-button>
      </span>
    </el-dialog>
    <el-dialog
      id="uploadDetail"
      ref="uploadDetail"
      title="上傳檔案明細"
      :visible.sync="openDetail"
      :close-on-click-modal="true"
      :show-close="true"
      :close-on-press-escape="false"
      :lock-scroll="true"
      class="upload"
      center
      @close="closeDetail"
    >
      <el-tabs
        id="feeTab"
        v-model="detailTabName"
        @tab-click="detailChange"
      >
        <el-tab-pane name="fail">
          <span slot="label">失敗</span>
          <div
            v-show="canUploadAgain"
            class="reUpload"
          >
            <span>※打開原始匯入檔案依照失敗明細修正各戶別錯誤原因後，點右方【重新上傳】</span>  <el-button
              round
              @click="rigister(true,detailConfig.Id)"
            >
              重新上傳
            </el-button>
          </div>
          <el-table
            class="newslist"
            :data="postalData.failList"
            empty-text="目前無任何包裹"
          >
            <el-table-column
              prop="TabletNote"
              label="戶別"
              width="150"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.TabletNote? scope.row.TabletNote : '此戶別已被刪除' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="CompleteAt"
              label="登記時間"
              width="150"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.CompleteAt.substr(0,16).replace(/-/g,"/") }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="ErrorMessage"
              label="錯誤原因"
            >
              <template slot-scope="scope">
                {{ scope.row.desc }}
              </template>
            </el-table-column>
          </el-table>
          <TableLoading :is-loading="detailLoading" />
        </el-tab-pane>
        <el-tab-pane name="success">
          <span slot="label">成功</span>
          <el-table
            class="newslist"
            :data="postalData.successList"
            empty-text="目前無任何包裹"
          >
            <el-table-column
              prop="TabletNote"
              label="戶別"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.TabletNote? scope.row.TabletNote : '此戶別已被刪除' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="CompleteAt"
              label="完成登記時間"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.CompleteAt.substr(0,16).replace(/-/g,"/") }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="Status" label="備註" width="110"></el-table-column> -->
          </el-table>
          <TableLoading :is-loading="detailLoading" />
        </el-tab-pane>
      </el-tabs>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="openDetail=false" round>關閉</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>
<script>
import TableLoading from '@/components/TableLoading'
export default {
  components: {
    TableLoading
  },
  data () {
    return {
      pageLoading: false,
      listData: [],
      loading: false,
      detailLoading: false,
      openUpload: false,
      openUploadAgain: false,
      openDetail: false,
      editData: { // 新增編輯期別資料
        UploadFile: null
      },
      detailTabName: 'fail',
      postalData: {
        successList: [],
        failList: []
      },
      typeList: [],
      reUploadItem: {
        Id: null
      },
      listCount: {
        offset: 0,
        maxCount: 10
      },
      detailConfig: {
        success: {
          offset: 0,
          maxCount: 10,
          scrollEnd: false
        },
        fail: {
          offset: 0,
          maxCount: 10,
          scrollEnd: false
        },
        status: 2,
        Id: null
      },
      nowType: '',
      scrollEnd: false,
      clicked: false,
      canScroll: true,
      stopLoadDetail: false,
      canUpload: false,
      canUploadAgain: false,
      canAutoshowDetail: false
    }
  },
  watch: {
    addDialog (status) {
      // eslint-disable-next-line eqeqeq
      if (status == false) {
        this.addDialog2 = false
      }
    },
    nowType (value) {
      console.log(value, '123')
      // eslint-disable-next-line eqeqeq
      if (value == '') {
        console.log('wrong')
        this.canUpload = false
      } else {
        this.canUpload = true
      }
    }
  },
  mounted () {
    vuecp.postal = this
    this.getData()
    this.getTypeList()
    window.addEventListener('scroll', this.autoShow, true)
    // var ScrollHeight = document.querySelector('#uploadDetail .el-dialog .el-tabs__content').scrollHeight
    // this.$refs.uploadDetail.$el.addEventListener('scroll', this.autoShowDetail, true);
    // document.querySelector('#uploadDetail .el-dialog .el-tabs__content').addEventListener('scroll', this.autoShowDetail, true);
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.autoShow, true)
    // document.querySelector('#uploadDetail .el-dialog .el-tabs__content').removeEventListener('scroll', this.autoShowDetail, true);
    // this.$refs.uploadDetail.$el.removeEventListener('scroll', this.autoShowDetail, true);
  },
  methods: {
    async getData () {
      const vm = this
      const ScrollHeight = document.querySelector('.pageRoot').scrollHeight

      vm.loading = true
      const data = {
        Offset: vm.listCount.offset,
        MaxCount: vm.listCount.maxCount
      }
      const res = await this.$getAPI(`${process.env.VUE_APP_CORE_URL}/api/Postal/BatchRegisterList`, 'GET', data)
      console.log(res)
      if (res.Postals.length < 10) {
        vm.scrollEnd = true
      }
      setTimeout(() => {
        for (const item of res.Postals) {
          item.statusObj = vm.transferStatus(item)
          vm.listData.push(item)
        }
        vm.loading = false
        if (vm.listData.length > 0) {
          window.scrollTo(0, ScrollHeight - 800)
        }
      }, 600)
    },
    // 下拉到底自動載入
    autoShow () {
      // 視窗滾動條高度
      const ScrollTop = document.documentElement.scrollTop
      // console.log(ScrollTop,'top')
      // 視窗可視範圍高度
      const ClientHeight = document.documentElement.clientHeight
      // console.log(ClientHeight,'視窗')
      // 內容實際高度
      const ScrollHeight = document.documentElement.scrollHeight
      // console.log(ScrollTop+ClientHeight)
      // console.log(ScrollHeight,'總高度')
      if ((ScrollTop + ClientHeight >= ScrollHeight - 10) && !this.loading) {
        if (!this.scrollEnd) {
          this.listCount.offset += 10
          this.getData()
        }
      }
    },
    autoShowDetail () {
      const vm = this
      // // 視窗滾動條高度
      const ScrollTop = document.querySelector('#uploadDetail .el-dialog .el-dialog__body').scrollTop
      // // 視窗可視範圍高度
      const ClientHeight = document.querySelector('#uploadDetail .el-dialog .el-dialog__body').clientHeight
      // // 內容實際高度
      const ScrollHeight = document.querySelector('#uploadDetail .el-dialog .el-dialog__body').scrollHeight
      console.log(ScrollTop + ClientHeight, ScrollHeight, 'autoshow')
      if ((ScrollTop + ClientHeight >= ScrollHeight - 1) && !vm.detailLoading && vm.canAutoshowDetail) {
        // eslint-disable-next-line eqeqeq
        if (vm.detailConfig.status == 2 && !vm.detailConfig.fail.scrollEnd) {
          vm.detailConfig.fail.offset += 10
          vm.getDetail()
        }
        // eslint-disable-next-line eqeqeq
        if (vm.detailConfig.status == 1 && !vm.detailConfig.success.scrollEnd) {
          vm.detailConfig.success.offset += 10
          vm.getDetail()
        }
      }
    },
    handleUploadFile (file) {
      this.editData.UploadFile = file
    },
    getExampleExcel () {
      const vm = this
      const url = `${process.env.VUE_APP_CORE_URL}/api/Postal/BatchRegisterSample`
      axios(url, {
        method: 'GET',
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
          'cache-control': 'no-cache',
          KingnetAuth: `Cookies ${vm.$getCookie('comLoginToken').replace('token=', '')}`
        },
        responseType: 'blob'
      }).then(res => {
        console.log(res)
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${decodeURIComponent(res.headers['content-disposition'].split(';')[2].replace(/"/g, '').replace("filename*=UTF-8''", '')).trim()}`) // or any other extension
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }).catch(err => {
        console.log(err)
      })
    },
    upLoad (again) {
      console.log('upload')
      const vm = this
      if (vm.clicked) {
        return false
      }
      vm.clicked = true
      console.log('upload,gogogo')

      if (vm.editData.UploadFile) {
        // eslint-disable-next-line eqeqeq
        if (vm.editData.UploadFile.name.indexOf('.xlsx') == -1 || this.editData.UploadFile.name.indexOf('.xlsx') + 5 != this.editData.UploadFile.name.length) {
          console.log('檔案不對')
          this.$message({
            message: '檔案格式有誤，請選擇檔案上傳',
            type: 'warning'
          })
          setTimeout(() => {
            vm.clicked = false
          }, 3000)
          return false
        }
        const requestData = new FormData()
        requestData.append('File', vm.editData.UploadFile.raw)
        // vm.editData.UploadFile.raw
        let url
        if (!again) {
          url = `${process.env.VUE_APP_CORE_URL}/api/Postal/UploadBatchRegisterFile`
          // nowType = nowType[0].Value
          requestData.append('PostalType', vm.nowType)
          console.log(requestData)
        } else {
          url = `${process.env.VUE_APP_CORE_URL}/api/Postal/ReUploadBatchRegisterFile`
          requestData.append('Id', this.reUploadItem.Id)
        }
        axios(url, {
          method: 'POST',
          data: requestData,
          headers: {
            'cache-control': 'no-cache',
            KingnetAuth: `Cookies ${vm.$getCookie('comLoginToken').replace('token=', '')}`
          }
        }).then(res => {
          console.log(res)
          // eslint-disable-next-line eqeqeq
          if (res.data.Status == 1 && Object.keys(res.data).length == 1) {
            vm.$alert('上傳成功', '', {
              confirmButtonText: '確定',
              callback: action => {
              }
            })
            // this.$message({
            //   message: '上傳成功',
            //   type: 'success'
            // });
            vm.editData.UploadFile = null
          } else {
            vm.$alert('上傳失敗', '', {
              confirmButtonText: '確定',
              callback: action => {

              }
            })
          }
          vm.listData = []
          vm.listCount = {
            offset: 0,
            maxCount: 10
          }
          setTimeout(() => {
            vm.clicked = false
          }, 3000)
          vm.scrollEnd = false
          vm.getData()
          vm.openUploadAgain = false
          vm.openUpload = false
          vm.reUploadItem.Id = null
        }).catch(err => {
          vm.$alert('上傳失敗', '', {
            confirmButtonText: '確定',
            callback: action => {

            }
          })
          setTimeout(() => {
            vm.clicked = false
          }, 3000)
          vm.listData = []
          vm.listCount = {
            offset: 0,
            maxCount: 10
          }
          vm.getData()
          vm.scrollEnd = false
          vm.openUploadAgain = false
          vm.openUpload = false
          vm.reUploadItem.Id = null
          console.log(err)
        })
      } else {
        this.$message({
          message: '請選擇檔案上傳',
          type: 'warning'
        })
        setTimeout(() => {
          vm.clicked = false
        }, 3000)
      }
    },
    cancelUpload () {
      this.openUploadAgain = false
      this.openUpload = false
      this.editData.UploadFile = null
    },
    goDetail (item) {
      const vm = this
      vm.detailTabName = 'fail'
      vm.canUploadAgain = false
      vm.canAutoshowDetail = true
      vm.openDetail = true
      vm.stopLoadDetail = false
      vm.detailConfig.Id = item.Id
      setTimeout(() => {
        document.querySelector('#uploadDetail .el-dialog .el-dialog__body').addEventListener('scroll', this.autoShowDetail, true)
      }, 500)
      // eslint-disable-next-line eqeqeq
      if (item.Status != 2 && item.StatusMessage != null) {
        // eslint-disable-next-line eqeqeq
        if (item.StatusMessage.Errors[0].ErrorCode != '400005') {
          vm.canUploadAgain = true
        }
      }
      vm.getDetail()
    },
    closeDetail () {
      console.log('closeDetail')
      const vm = this
      vm.openDetail = false
      vm.postalData.successList = []
      vm.postalData.failList = []
      document.querySelector('#uploadDetail .el-dialog .el-dialog__body').removeEventListener('scroll', this.autoShowDetail, true)
      vm.stopLoadDetail = true
      vm.canAutoshowDetail = false
      vm.detailConfig = {
        success: {
          offset: 0,
          maxCount: 10,
          scrollEnd: false
        },
        fail: {
          offset: 0,
          maxCount: 10,
          scrollEnd: false
        },
        status: 2,
        Id: null
      }
    },
    async getDetail () {
      const vm = this
      vm.detailLoading = true
      let ScrollHeight
      setTimeout(() => {
        ScrollHeight = document.querySelector('#uploadDetail .el-dialog .el-dialog__body').scrollHeight
      }, 500)
      let data
      // eslint-disable-next-line eqeqeq
      if (vm.detailConfig.status == 2) {
        data = {
          Id: vm.detailConfig.Id,
          Offset: vm.detailConfig.fail.offset,
          MaxCount: vm.detailConfig.fail.maxCount,
          Status: vm.detailConfig.status
        }
      } else {
        data = {
          Id: vm.detailConfig.Id,
          Offset: vm.detailConfig.success.offset,
          MaxCount: vm.detailConfig.success.maxCount,
          Status: vm.detailConfig.status
        }
      }

      const res = await this.$getAPI(`${process.env.VUE_APP_CORE_URL}/api/Postal/BatchRegisterDetail`, 'GET', data)
      console.log(res, 'resss')
      // eslint-disable-next-line eqeqeq
      if (res.status != 400) {
        if (res.Tablets.length < 10) {
          // eslint-disable-next-line eqeqeq
          if (vm.detailConfig.status == 2) {
            vm.detailConfig.fail.scrollEnd = true
          } else {
            vm.detailConfig.success.scrollEnd = true
          }
        }
        setTimeout(() => {
          if (!vm.stopLoadDetail) {
            for (const item of res.Tablets) {
              // eslint-disable-next-line eqeqeq
              if (item.Status == 1) {
                vm.postalData.successList.push(item)
              } else {
                item.desc = vm.translateError(item)
                vm.postalData.failList.push(item)
              }
            }
            vm.detailLoading = false
            document.querySelector('#uploadDetail .el-dialog .el-dialog__body').scrollTo(0, ScrollHeight - 800)
          }
        }, 1000)
      }
    },
    detailChange () {
      const vm = this
      if (vm.clicked) {
        return false
      }
      vm.clicked = true
      switch (this.detailTabName) {
        case 'fail':
          vm.detailConfig.status = 2
          setTimeout(() => {
            vm.clicked = false
          }, 1500)
          break
        case 'success':
          vm.detailConfig.status = 1
          // eslint-disable-next-line eqeqeq
          if (vm.postalData.successList.length == 0) {
            vm.getDetail()
          }
          setTimeout(() => {
            vm.clicked = false
          }, 1500)
          break
        default:
          break
      }
    },
    transferStatus (patch) {
      switch (patch.Status) {
        case 1:
          return { text: '處理中', class: 'status-processing', desc: '請稍後，正在登記上傳郵務資料' }
        case 2:
          return { text: '成功', class: 'status-on', desc: '登記成功，請至未領取包裹列表查看' }
        case 3:
          if (patch.SuccessCount > 0) {
            return { text: '異常', class: 'status-warning', desc: '部分戶別登記有誤，請查看上傳明細，並修正失敗的資料後重新上傳' }
          } else {
            switch (patch.StatusMessage.Errors[0].ErrorCode) {
              case '400001':
                return { text: '失敗', class: 'status-offline', desc: '社區ID錯誤，請重新下載空白範本，並填寫郵務資料後重新上傳。' }
              case '400003':
                return { text: '失敗', class: 'status-offline', desc: '戶別ID錯誤，請重新下載空白範本，並填寫郵務資料後重新上傳。' }
              case '400004':
                return { text: '失敗', class: 'status-offline', desc: '戶別資料非本社區，請重新下載空白範本，並填寫郵務資料後重新上傳。' }
              case '400005':
                return { text: '失敗', class: 'status-offline', desc: '此類型已被刪除，請新增類型後重新登記' }
              case '400006':
                return { text: '失敗', class: 'status-offline', desc: '部分戶別登記有誤，請查看明細，並修正失敗的資料後重新上傳' }
              case '400007':
                return { text: '失敗', class: 'status-offline', desc: '戶別資料重複，檔案中每戶郵務資料僅限一筆，請刪除重複戶別' }
              case '400008':
                return { text: '失敗', class: 'status-offline', desc: '資料格式錯誤,請重新下載空白範本,並填寫郵務資料後重新上傳' }
              case '400009':
                return { text: '失敗', class: 'status-offline', desc: '資料格式錯誤,請重新下載空白範本,並填寫郵務資料後重新上傳' }
              default:
                return { text: '失敗', class: 'status-offline', desc: '資料格式錯誤,請重新下載空白範本,並填寫郵務資料後重新上傳' }
            }
          }
        case 4:
          return { text: '處理中', class: 'status-processing', desc: '請稍後，正在登記上傳郵務資料' }
        default:
          return { text: '失敗', class: 'status-offline', desc: '資料格式錯誤,請重新下載空白範本,並填寫郵務資料後重新上傳' }
      }
    },
    translateError (item) {
      switch (item.ErrorMessage.ErrorCode) {
        case '400001':
          return '流水號已達上限,請先結單未領取包裹'
        case '400002':
          return '戶別已被刪除,無法登記'
        case '400003':
          return '字數超過30字,請修改字數後重新上傳'
        case '400004':
          return '字數超過18字,請修改字數後重新上傳'
        case '400005':
          return '收件人及備註皆超過字數限制,請修改字數後重新上傳'
        default:
          break
      }
    },
    getTypeList () {
      axios(`${process.env.VUE_APP_MAPI_URL}/CustomType/List`, {
        method: 'GET',
        headers: { Authorization: this.$getCookie('comLoginToken').replace('token=', '') },
        params: { CustomType: 'PostalType' }
      }).then(res => {
        this.typeList = res.data.Data.List
        res.data.Data.List.map(val => val.select = false)
        this.typeList = res.data.Data.List
        const sortList = this.typeList.sort((a, b) => {
          return a.Id - b.Id
        })
        this.nowType = sortList[0].Value
      }).catch(err => {
        console.log(err.response)
      })
    },
    selectType (type_ind) {
      this.typeList.map(val => val.select = false)
      this.$set(this.typeList[type_ind], 'select', true)
      console.log(type_ind)
    },
    rigister (again, Id) {
      if (again) {
        this.openUploadAgain = true
        // if(this.detailConfig.Id!=null){
        //   this.reUploadItem.Id = Id
        // }
        this.reUploadItem.Id = Id
        this.closeDetail()
      } else {
        // eslint-disable-next-line eqeqeq
        if (this.typeList.length == 0) {
          this.$alert('包裹類型已全被刪除，請新增類型後再進行登記', '', {
            confirmButtonText: '確定',
            callback: action => {
            }
          })
        } else {
          this.openUpload = true
        }
      }
    },
    clearFile () {
      this.editData.UploadFile = null
      // setTimeout(() => {
      // this.editData.UploadFile= null

      // }, 2000);
    },
    openPage () {
      window.open('https://www.smartdaily.com.tw/postalpatch.html', '_blank')
    }
  }
}
</script>
<style lang="sass" scoped>
.pageRoot
  text-align: center
  padding: 50px 0 10px
  height: 100%
  #uploadDetail
    color: pink
    ::v-deep  .el-dialog
      height: 80% !important
      overflow-y: hidden !important
      .el-dialog__body
        overflow: scroll !important
        height: 78% !important
  ::v-deep .el-dialog
    // height: 80%
    // overflow-y: scroll !important
    +basicDialog
    .reUpload
      color: $dangerColorActive
      margin-bottom: 20px
      text-decoration: underline
      button
        margin-left: 10px
    .upload
      .el-dialog__footer
        border: none

    .remind
      color: $bgDark1
      display: inline-block
      border: none
      width: 100%
      margin-bottom: 10px
    .comment
      p
        line-height: 16px
        margin-bottom: 16px
  ::v-deep .el-dialog__wrapper
    &.upload
      .el-dialog__footer
        border: none
  .main
    min-width: 1140px
    max-width: 90%
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      margin: 0 0 20px 0
      .introduction
        color: $mainColorDark
        font-size: 20px
        font-weight: initial
        margin: 0 10px
        text-decoration: underline
        cursor: pointer
        &:before
          content: '('
          color: #000
        &:after
          content: ')'
          color: #000
      .questionnaire
        background-color: $bgDark3
        padding: 5px 8px
        span
          color: $mainColor
          cursor: pointer
          margin: 0 10px 0 13px
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        margin-bottom: 10px
        text-align: left
      .tip
        font-size: map-get($fontSize,small)
        color: $subFontColor
    .title_bar.center
      margin: 20px 0 10px 0
    .newslist
      font-size: 15px
      .file-name
        cursor: pointer
        color: $mainColorDark
      .cell
        +NewsStatusTag
      .news-title
        cursor: pointer
        color: $mainColorDark
        text-decoration: underline
      ::v-deep .el-table
        +basicTable

.basicSetting
  width: 100%
  .block
    display: flex
    flex-wrap: wrap
    &:not(:first-child)
      margin-top: 15px
    .block_left
      width: 20%
    .block_right
      display: flex
      flex-wrap: wrap
      width: 80%
      .description
        width: 100%
      .normalFont
        font-size: 15px
        color: #333
        margin-right: 20px
        line-height: 30px
      .normalFont  ::v-deep .el-input__inner
        height: 30px !important
        font-size: 15px !important
      .normalSize  ::v-deep .el-input__inner
       font-size: 15px !important
  .down
    border-top: none
.postalL-list-content
  color: #606266
  font-size: 15px
  width: 100%
  .el-row
    margin: 5px 0
    // padding: 12px 0
    border: solid 1px #ccc
    border-radius: 5px
    text-align: center
    background-color: rgba(255,255,255,1)
    &.listHead
      font-weight: bold
      color: #909399
    &.sortable-ghost
      opacity: 0
    &.sortable-drag
    .dragHandler
      flex-basis: 50px
      text-align: right
      i
        font-size: 15px
        color: #fff
        background-color: #41A07D
        border-radius: 50%
        padding: 3px
    .indexNum
      flex-basis: 80px
    .typeName
      flex: 1
      text-align: left
      word-break: break-word
    .operationBtn
      flex-basis: 170px
      text-align: left
el-dialog
    min-width: 750px
.noBorder ::v-deep .el-input__inner
  border: none !important
.noFocusEffect
    color: #666
    border-color: #ccc
    background-color: #FFFFFF
    &:hover
      color: $mainColor
      border-color: #c6e2d8
      background-color: #ecf5f2
.normalInput  ::v-deep .el-input__inner
  height: 30px !important
  font-size: 15px !important
.alignRight
  text-align: right !important
  margin-right: 10px
.el-input__inner
  font-size: 15px !important
.arrange
  float: right
  margin-top: 3px
  padding-left: 10px
.disabledGrey ::v-deep [disabled="disabled"]
  background-color:$bgDark3 !important
.cursorMove
  cursor: move
  .normalList,.typeName,.operationBtn,.noBorder, ::v-deep .el-input__inner,&.sortable-chosen,&.sortable-ghost
    cursor: move
.sortable-chosen, .sortable-ghost
  cursor: move !important
.uploadFileWrap
  display: inline-block
  width: 100%
  margin: 5px 0
.uploadedFile
  display: inline-block
  float: left
  margin-top: 10px
  &.active
    border-radius: 5px
    padding: 0 0 0 10px
    line-height: 1
    .fileName
      display: inline-block
      span
        vertical-align: middle
        word-break: break-all
      i
        color: $dangerColor
        vertical-align: middle
        padding: 0 5px
.emptyFile
  color: $subFontColor
  span
    color: $mainColor
    cursor: pointer
.remind
  border: solid 1px $bgDark1
  .container
    padding: 20px
    background-color: $bgDark4
    .title
      font-size: 20px
      margin-bottom: 12px
      font-weight: 500
      color: $mainFontColor
      .tutorial
        color: $mainColor
        cursor: pointer
    .desc
      font-size: 16px
      line-height: 34px
      color: $subFontColor
.payMethods
  span
    color:  $mainColor
    border: solid 1px $mainColor
    background-color: $white
    cursor: pointer
  span.active
    color:  $white
    border: solid 1px $mainColor
    background-color: $mainColor
.newslist
  font-size: 15px
  .file-name
    cursor: pointer
    color: $mainColor
  .cell
    +NewsStatusTag
  .news-title
    cursor: pointer
    color: $mainColorDark
    text-decoration: underline
  ::v-deep .el-table
    +basicTable

.btn.disabled
  background-color: $bgDarkBg

</style>
